import { gql } from '@apollo/client';

import { FACILITY_FRAGMENT } from '../fragments';
import { CORE_ESG_VALUE_FIELDS } from '../fragments/esgValue';

export const GET_ESG_KPIS = gql`
  query EsgKpis($categoryLevel: EsgCategoryLevel) {
    esgKpis(categoryLevel: $categoryLevel) {
      id
      title
      parentId
      category {
        title
        id
        area
        level
      }
      description
      frameworks {
        esrs
        gri
        dnk
      }
      source
      units
      type
      esrsReference
      semiNarrativeOptions
    }
  }
`;

export const GET_SELECT_DATA_ENTRY_QUESTION_DATA = gql`
  ${CORE_ESG_VALUE_FIELDS}
  ${FACILITY_FRAGMENT}
  query GetSelectDataEntryQuestionData($reportChapterId: ID!, $year: Int!) {
    esgValuesByYearMaterialTopicId(id: $reportChapterId, year: $year) {
      ...CoreEsgValueFields
      proofDocuments {
        id
        name
        type
        uploadDate
      }
    }
    globalFacility {
      ...facilityValues
    }
  }
`;
